var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1300 1455.5",
    style: {
      enableBackground: "new 0 0 1300 1455.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1202.6,252.6c60.7,66.3,97.4,150.7,97.4,254c0,363.5-221.4,443.5-432.1,466.9c33.9,29.4,64.2,87,64.2,175.3 c0,126.6-1.1,228.5-1.1,259.7c0,20.8,11.7,44.6,42.8,47h-556c31.8-2.1,44-26,44-47c0-22.6-0.9-97.1-1.3-176.2 c-263.3,57.2-318.8-111.7-318.8-111.7c-43-109.4-105.1-138.5-105.1-138.5c-85.9-58.7,6.5-57.5,6.5-57.5 c95,6.7,145.1,97.5,145.1,97.5c84.4,144.7,221.4,102.8,275.4,78.7c8.5-61.2,33-102.9,60.1-126.5c-210.3-23.9-431.3-105-431.3-467.7 c0-103.3,37-187.7,97.5-254c-9.8-23.8-42.2-120.1,9.2-250.4c0,0,79.5-25.4,260.3,97c75.5-21,156.4-31.5,236.9-31.8 c80.4,0.4,161.4,10.9,237.1,31.8c180.6-122.4,260-97,260-97C1244.8,132.5,1212.4,228.8,1202.6,252.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubDark);
export default __webpack_public_path__ + "static/media/github_dark.6930a5aa8fe379aec162d701fe81b610.svg";
export { ForwardRef as ReactComponent };